module.exports = __webpack_public_path__ + "static/img/amd7.679718e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd7.png
// module id = H0Ri
// module chunks = 1